import { Outlet } from "react-router-dom";
import SignIn from "./auth/SignIn";
import { useAuth } from "../firebase";

const PrivateRoute = () => {
    const isAuth = useAuth();
    return isAuth ? <Outlet /> : <SignIn />
}

export default PrivateRoute;